import svg from './row-svg/alert.svg';
import { FixMe } from '@greenkub-fronts/shared/interface';

export function AlertIcon(props: FixMe) {
  return <img {...props} src={svg} alt="svg" />;
}

export default AlertIcon;
